import { Box, IconMessage, Button } from 'braid-design-system';

interface CommentButtonProps {
  commentLabel: string;
  onClick?: () => void;
}

export default ({ commentLabel, onClick }: CommentButtonProps) => (
  <Box borderRadius="full">
    <Button
      variant="transparent"
      tone="neutral"
      icon={<IconMessage />}
      onClick={onClick}
      size="small"
    >
      {commentLabel}
    </Button>
  </Box>
);
